/** 应用公共枚举值 */

// 优惠券状态修改类型
export enum CouponStatusModifyType {
  REVOKE = 1, // 撤回
  CLOSE = 2 // 下架
}

// 优惠券业务场景
export enum CouponBusinessScene {
  FILM = 'film', // 电影票
  LIANLIAN = 'll', // 联联
  INSURANCE = 'insurance', // 保险
  ZDS = 'zds',//直销
}

//商品分类
export enum GoodsCatIds {
  LIANLIAN_HOTEL = '180', // 联联-酒店住宿类
  LIANLIAN_TICKET = '255', // 联联-游乐票务类
  INSURANCE = '9102', // 保险-包裹险
  INSURANCE_LEVEL2 = '920102', // 保险-包裹险
  INSURANCE_PACKAGE = '93020201', // 保险-包裹险
  INSURANCE_PROPERTY = '93020202', // 保险-财产&公责险
  DIRECT_BOX_PACKAGE_GUARANTEE = '93020203',
  DIRECT_BOX_PROPERTY_GUARANTEE = '93020204',
}

export enum CouponBusinessCat {
  LL_HOTEL = GoodsCatIds.LIANLIAN_HOTEL, // 联联-酒店住宿类
  LL_TICKET = GoodsCatIds.LIANLIAN_TICKET, // 联联-游乐票务类
  INSURANCE = GoodsCatIds.INSURANCE_PACKAGE, // 保险-包裹险
  INSURANCE_PACKAGE = GoodsCatIds.INSURANCE_PACKAGE, // 保险-包裹险
  INSURANCE_PROPERTY = GoodsCatIds.INSURANCE_PROPERTY // 保险-财产&公责险
}

/** 优惠券/包CDKey生成状态 */
export enum CouponCDKeyGenerateStatus {
  PENDING = 0, // 待生成
  GENERATING = 1, // 生成中
  FINISHED = 2 // 生成完成
}

// 优惠券类型
export enum CouponType {
  DEFAULT = 0, // 默认
  ORDER_DEDUCTION = 1, // 订单抵扣
  VERTICAL_REDUCTION = 2, // 立减券
  FREE_CHARGE = 3, // 免单券
  GOODS_FREE = 4, //商品抵扣券
  GOODS_FREE_ZDS = 5, //商品抵扣券

  NO_THRESHOLD_COUPON = 6, //商品抵扣券
}

/** 优惠券发放类型 */
export enum CouponIssueLimitType {
  TOTAL = 0, // 累计发放
  DAILY = 1 // 每日限量
}

// 优惠券状态
export enum CouponStatus {
  NORMAL = 0, // 正常状态
  REVOKED = 1, // 已撤销
  CLOSED = 2 // 已下架
}

/** 优惠券免单 */
export enum CouponFreeChargeType {
  LIMIT_FREE = 1, // 按订单内规格免单
  ALL_FREE = 2 // 直接免单
}

/** 优惠券包CDKey生成方式 */
export enum CouponCDKeyGenerateMethod {
  API = 0, // API生成
  PER = 1 // 预生成
}

// 优惠券发放类型
export enum CouponGrantType {
  DEFAULT = 0, // 默认
  TICKET = 1, // 兑换券
  PHONE_NUMBER = 2, // 手机号
  USER_ID = 3, // 用户ID
  COUPON_BAG = 4, // 券包发放
  DEPOT_ID = 5 // 门店ID
}

/** 跳转类型 */
export enum JumpType {
  TUXI = 'tuxi', // 跳转兔喜小程序
  OUTER = 'outer', // 跳转外部小程序
  GOODS = 'goods', // 跳转商品
  H5 = 'h5', // 跳转H5
  NONE = 'none' // 不跳转
}

/** 券业务组类型（券/券包） */
export enum CouponBizGroupType {
  COUPON = 'coupon', // 券
  COUPON_BAG = 'couponBag' // 券包
}

/** 活动位 */
export enum ActivityPlace {
  BANNER_TOP = '1',
  BANNER2_LEFT = '2',
  BANNER2_RIGHT = '3',
  BANNER_MIDDLE = '4',
  AKC_BRAND_LIST = '5',
  LIANLIAN_LIST = '6',
  TIME_LIMIT = '7',
  TAKEOUT_LIST = '8'
}

/** 活动跳转方式 */
export enum ActivityJumpType {
  GOODS_DETAIL = 'goodsDetail',
  OTHER = 'other'
}

/** 应用公共枚举值 */
export enum YesNo {
  NO = 0,
  YES = 1
}

export enum DiscountMethodType {
  ZHIJIAN = 7, // 直减
  DISCOUNT = 8 // 折扣
}

export enum DayCouponIssueLimitType {
  TOTAL = 1, // 累计发放每人
  DAILY = 2, // 每人每日限量
  NONE = 0 // 不限

}

export enum ZdsActivityType {
  All=0,
  GOODS=1
}

/** 是否字符串 */
export enum YesNoStr {
  NO = '0',
  YES = '1'
}

/** 营销页商品类型 */
export enum GoodsType {
  NONE = 'none', // 无
  COUPON = 'coupon', // 优惠券
  TAKEOUT = 'takeout', // 外卖
  MTZ_SHOP = 'mtz_shop', // 美团到店
  FILM = 'film', // 电影
  LIANLIAN = 'll', // 联联
  AIKUCUN = 'akc', // 爱库存
  AIKUCUN_ACTIVITY = 'akc_activity', // 爱库存
  YOU_ZAN = 'you_zan',
  OTHER = 'other', // 其他
  ZDS = 'zds',//中通直供
}



/** 活动投放维度 */
export enum ActivityEffectiveType {
  ALL = 0, // 全国
  PROVICE_CITY = 1 // 地区
}

/** 菜单类型 */
export enum DialogType {
  ADD = 0,
  EDIT = 1,
  VIEW = 2
}

/** 活动循环周期 */
export enum ActivityCycleType {
  NONE = 0,
  MONTH = 1,
  WEEK = 2
}


/** 活动映射类型 */
export enum ActivityBizType {
  ACTIVITY = 'activity',
  GOODS = 'goods'
}

/** 禁用，启用 */
export enum EnableStatus {
  DISABLE = 0,
  ENABLE = 1
}

/** 合作商禁用，启用 */
export enum AgentEnableStatus {
  DISABLE = 30,
  ENABLE = 20
}

/** 用户权限 */
export enum UserPermissons {
  // 查看工单结算金额
  OPERATE_WORKORDER_AMOUNT_VIEW = 'com.zto.tuxi.operate.dto.res.kdcs.WorkOrderDetailRes.amount'
}

/**
 * 待办任务
 */
export enum TodoTaskStatus {
  PENDING = 'pending', // 待处理
  COMPLETED = 'completed', // 已完成
  CLOSED = 'close' // 已关闭
}

// 运营平台/网点垫资装修门店打款状态
export enum OperateAdvanceFundPayStatus {
  PAID = 1, // 已打款
  UNPAID = 0 // 未打款
}

// 运营平台/网点垫资装修门店打标状态
export enum OperateAdvanceFundMarkStatus {
  SUCCESS = 1, // 打标成功
  FAILED = 0 // 打标失败
}

// 运营平台/网点垫资装修门店新增状态
export enum OperateAdvanceFundAddStatus {
  PENDING = 0, // 新增中
  SUCCESS = 1, // 新增成功
  FAILED = 2 // 新增失败
}

// 运营平台/网点垫资装修门店打标状态
export enum OperateAdvanceFundMarkStatus {
  NOT_MARKED = 0, // 未打标
  MARKED = 1 // 已打标
}

// 运营平台/网点垫资装修门店装修认证状态
export enum OperateRenovationAuthStatus {
  NOT_APPLIED = 0, // 未申请
  FAILED = 10, // 审核失败
  PENDING = 20, // 审核中
  PASSED = 30, // 审核通过
  REJECTED = 40 // 不通过
}

// 运营平台流程业务类型
export enum OperateFlowBizType {
  TRIAL_ACCOUNT = 1, // 试用账号
  STORE_CERT = 10, // 门店认证
  DECORATION_CERT = 20, // 装修认证
  STORE_QUIT = 50, // 门店退出
  STORE_QUIT_MATERIAL = 60, // 门店退出材料
  DEVICE_SUBSIDY = 70, // 设备补贴
  DEVICE_TRANSFER = 90, // 门店转让
  STORE_UPDATE = 100, // 门店修改审核
  ACTIVITY_REGISTRACTIONS = 110, // 活动报名审核
  FILING_RECEIPT = 130, // 末端备案回执
  REVEAL_STORE = 150, // 承包区化门店审核
  TFSTORE_CERT = 180 //24小时门店认证
}

// 短信模版审核状态
export enum OperateSimpleApproveStatus {
  PENDING = 0, // 未审核
  PASS = 1, // 审核通过
  REJECT = 2 // 审核拒绝
}

// 快递超市相关审核状态
export enum OperateKdcsApproveStatus {
  PENDING = 0, // 待审核
  ISP_PASS = 10, // 预审通过
  ISP_NOT_PASS = 20, // 预审不通过
  CITY_MANAGER_PASS = 30, // 初审通过
  CITY_MANAGER_NOT_PASS = 40, // 初审不通过
  HQ_REJECT = 50, // 终审驳回
  HQ_PASS = 60, // 终审通过
  HQ_NOT_PASS = 70, // 终审不通过
  HQ_REFUSE = 80 //拒绝
}
// 拨测状态 拨测状态 0-待拨测 1-拨测成功 2-拨测失败
export enum PhoneCallStatus {
  PENDING = 0,
  PASS = 1,
  FAIL = 2
}
// 门店清退状态
export enum OperateStoreQuitClearStatus {
  PENDING = 1, // 待清退
  QUITED = 2 // 已清退
}

// 补贴类型
export enum OperateSubsidyTypes {
  DECORATION_SUBSIDY = 1, // 装修补贴
  DEVICE_SUBSIDY = 2, // 设备补贴申请
  INDEX_SUBSIDY = 3, // 指数补贴
  DEVICE_SUBSIDY_SETTLE = 4 // 设备补贴申请结算
}

// 是否风控门店
export enum OperateRiskStore {
  YES = 0, // 是
  NO = 1 // 否
}

// 门店风控状态
export enum OpStoreRiskStatus {
  CLEARED = 1, // 已解除
  UNCLEARED = 0 // 未解除
}

// 补贴状态
export enum OperateSubsidyStatus {
  PENDING = 1, // 审核中
  SUBSIDY_IN = 2, // 补贴中
  NOT_PASS = 3, // 审核不通过
  SUBSIDIZED = 4, // 已补贴
  REJECTED = 5 // 已拒绝
}

// 系统流程参数类型
// export enum SystemProcessParamType {
//   BOOLEAN = 1, // boolean型
//   NUMBER = 2, // number型
//   STRING = 3, // string型
//   JSON = 4 // json型
// }

// 运营平台/网点垫资装修门店新增状态
export enum SystemStoreParamsAddStatus {
  FAILED = 0, // 新增中
  SUCCESS = 1 // 新增成功
}

// 门店认证状态
export enum OperateStoreAuthStatus {
  NO_APPLICATION = -1, // 未申请
  PENDING = 0, // 审核中
  PASS = 1, // 审核通过
  NOT_PASS = 2 // 审核不通过
}

// 工单状态
export enum OperateWorkOrderStatus {
  PENDING = 0, // 待接单
  UNFINISHED = 99, // 未完成
  TIMEOUT = 2, // 已超时
  SUCCESS = 1, // 已完成
  FAILED = 3 // 异常上报
}

// 下发门店状态
// 门店认证通过且装修认证未通过=1,长期账号=2,门店认证未通过且装修认证未通过且非长期账号=3,门店认证通过且装修认证通过=4,门店认证未通过且装修认证通过=5
export enum OperateIssueStoreStatus {
  STORE_CERT_AND_NOT_DECORATION_CERT = 1, // 门店认证通过且装修认证未通过
  LONG = 2, // 长期账号
  NOT_STORE_CERT_AND_NOT_DECORATION_CERT_AND_NOT_LONG = 3, // 门店认证未通过且装修认证未通过且非长期账号
  STORE_CERT_AND_DECORATION_CERT = 4, // 门店认证通过且装修认证通过
  NOT_STORE_CERT_AND_DECORATION_CERT = 5 // 门店认证未通过且装修认证通过
}

// 工单详情-商业情况-证件资质
export enum OperateCertificateCertification {
  'businessLicenseImg' = '营业执照',
  'foodBusinessLicenseImg' = '食品经营许可证',
  'tobaccoCardImg' = '烟草证',
  '无资质' = '无资质'
}

// 上门服务费结算-结算状态
export enum OperateSettleStatus {
  NO_SETTLE = 0, // 未结算
  PENDING = 10, // 结算中
  SUCCESS = 20 // 已结算
}

// 上门服务费结算-审核状态
export enum OperateAuditStatus {
  PENDING = 0, // 审核中
  SUCCESS = 1, // 审核通过
  FAILED = 2 // 审核不通过
}

// 短信模板-审核状态
export enum OperateApproveStatus {
  PENDING = 0, // 待审核
  SUCCESS = 1, // 审核通过
  FAILED = -1 // 拒绝审核
}

// 送货上门订单数据-快件类型
export enum OperateWaybillType {
  STANDARD = 'STANDARD_TYPE', // 中通标快
  VIP = 'VIP_TYPE' // 中通尊享
}

/**
 * 满意度收集采集点状态
 */
export enum OpSatCollectionPointStatus {
  ONLINE = 1,
  OFFLINE = 0
}

/**
 * 满意度收集采集点样式
 */
export enum OpSatCollectionPointStyles {
  DIALOG = 0
}

/**
 * 满意度收集采集点默认分组
 */
export enum OpSatCollectionGroupId {
  ENUM = 1, // 选择题
  TEXT = 2 // 文本题
}

/**
 * 满意度收集采集点问题类型
 */
export enum OpSatCollectionQuestionType {
  ENUM = 'ENUM', // 选择题
  TEXT = 'TEXT' // 文本题
}

/**
 * 批量解除临关-配置类型
 */
export enum OpCloseType {
  DEPOTCODES = 2, // 按门店编号
  BATCHCODE = 1 // 按批次号
}

/**
 * 盘点类型：意向点&热点
 */
export enum OpInventoryType {
  HOT = 'hot', // 热点
  INTENTION = 'intention' // 意向点
}

// 保证金扣款-保证金状态:1:是,0:否
export enum OpMarginStatus {
  YES = 1, // 是
  NO = 0 // 否
}

// 系统 >> 操作日志 >> 操作类型
export enum OperateType {
  ADD = 'I', // 新增
  MODIFY = 'U', // 修改
  DELETE = 'D' // 删除
}

// 客服 - 工单状态
export enum ComplainWorkorderStatus {
  UNASSIGNED = 10, // 未分配
  PENDING = 20, // 待处理
  PROCESSING = 30, // 处理中
  RESOLVED = 40, // 已解决
  CLOSED = 50 // 已关闭
}

// 客服 - 紧急程度
export enum ComplainDegreeUrgency {
  COMMON = 1, // 普通
  EMERGENCY = 2 // 紧急
}

// 消费者投诉处理 - 投诉渠道
export enum ComplainConsumerChannel {
  WECHATPAY = 'wechat_pay', // 微信支付
  ALIPAY = 'alipay', // 支付宝
  WECHATMINIPROGRAM = 'wechat_mini_program' // 微信小程序
}

// 消费者投诉处理 - 投诉单状态
export enum ComplainConsumerStatus {
  PENDING = 'PENDING', // 待处理
  PROCESSING = 'PROCESSING', // 处理中
  RESOLVED = 'PROCESSED' // 已解决
}

// 消费者投诉处理 - 是否同意退款
export enum ComplainConsumerAction {
  APPROVE = 'APPROVE', // 同意退款
  REJECT = 'REJECT' // 拒绝退款
}

// 量本利科目维护 - 计算属性
export enum QcpComputeType {
  MANUAL_ENTRY = 0, // 手动录入
  SYSTEM = 1, // 系统取值
  TOTAL = 2 // 合计
}

/** 跳转类型 */
export enum TodoTaskJumpModel {
  JUMP_RN = 1,
  JUMP_H5 = 2,
  JUMP_APP = 3
}

/** 活动状态 */
export enum ActivityStatus {
  NOT_PUBLISHED = 0, // 未发布
  PUBLISHED_NOT_EXECUTED = 10, // 未开始
  PUBLISHED_PENDING = 20, // 进行中
  PUBLISHED_END = 30, // 已结束
  REVOKED = 40 // 已撤销
}

/** 合作商类型 */
export enum AgentLevel {
  ONE = 'one', // 一级合作商
  TWO = 'two', // 二级合作商
  THREE = 'three' // 三级合作商
}

/** 门店绑定类型 */
export enum StoreBindType {
  SELF_SUPPORT = 1, // 快递自营门店绑定
  SHELFT = 2 //智能货架门店绑定
}

/** 扣款状态 */
export enum DebitStatus {
  SUCCESS = 3,
  FAILED = 60,
  PENDING = 2
}

/** 售后工单-处理状态 */
export enum AftermarketWorkOrderStatus {
  UNSHARE = 10,
  UNDISPATCH = 20,
  PENDING = 30,
  PROCESSING = 40,
  PROCESSED = 50,
  FILED = 60,
  HUNGED = 70,
  CANCELLED = 80
}

/** 售后工单-紧急程度 */
export enum AftermarketWorkOrderLevel {
  NORMAL = 1,
  URGENT = 2
}

/** 售后服务-处理状态 */
export enum WorkOrderStatus {
  UNDISPATCH = -10,
  UNREC = 0,
  DEALING = 10,
  PENDING = 20,
  DEALED = 30,
  FINISH = 40,
  REVOKE = -20
}
/** 售后工单-紧急程度 */
export enum WorkOrderLevel {
  NORMAL = 1,
  URGENT = 2
}
// CREATE_WORK_ORDER(10, "创建工单"),
// DISTRIBUTE(30, "分单"),
// DISPATCH(50, "派单"),
// RECEIVE(70, "接单"),
// RETURN(90, "退单"),
// HANG_UP(110, "挂起"),
// CANCEL_HANG_UP(130, "取消挂起"),
// REMINDER(150, "催单"),
// DISPOSE(170, "处理工单"),
// COMMENT(190, "评价"),
// CANCEL(200, "撤销"),
// ADD_DESC(210, "新增描述"),
export enum AftermarketButtonStatus {
  CREATE_WORK_ORDER = 10,
  DISTRIBUTE = 30,
  DISPATCH = 50,
  RECEIVE = 70,
  RETURN = 90,
  HANG_UP = 110,
  CANCEL_HANG_UP = 130,
  REMINDER = 150,
  DISPOSE = 170,
  COMMENT = 190,
  CANCEL = 200,
  ADD_DESC = 210
}
/***
 * 采销系统
 *
 */
/** 采购类型 */
export enum PurchaseType {
  HC = 'HC', // 回采
  XC = 'XC' // 新采
}

/** 采购状态 */
export enum PurchaseStatus {
  WAIT_PURCHASE = 'wait_purchase', // 待接单
  WAIT_DELIVERY = 'wait_delivery', // 待发货
  CANCEL_PURCHASE = 'cancel_purchase', // 已取消
  PART_DELIVERY = 'part_delivery', // 部分发货
  ALL_DELIVERY = 'all_delivery', // 全部发货
  SIGN_COMPLETE = 'sign_complete' // 已签收
}

/** 销售订单操作按钮 */
export enum SalesOrderOperateStatus {
  VIEW_BUTTON = 'view_button', // 详情按钮
  EDIT_BUTTON = 'edit_button', // 编辑按钮
  CLOSE_BUTTON = 'close_button', // 取消按钮
  CHECK_BUTTON = 'check_button', // 审核按钮
  DO_SCHEDULE_BUTTON = 'do_schedule_button', // 排产按钮
  CANCEL_SCHEDULE_BUTTON = 'cancel_schedule_button', // 取消排产按钮
  CONFIRM_RECEIPT_BUTTON = 'confirm_receipt_button', // 确认收货按钮
  AFTER_SALE_BUTTON = 'after_sale_button', // 申请售后按钮
  WRITE_ORDER_CODE_BUTTON = 'write_order_code_button', // 填写单号按钮
  RETURN_CHECK_BUTTON = 'return_check_button', // 退货验收按钮
  CONFIRM_BUTTON = 'confirm_button', // 去确认按钮
  SIGN_BUTTON = 'sign_button', // 去签约按钮
  PAY_BUTTON = 'pay_button', // 去付款按钮
  REFUND_BUTTON = 'refund_button', // 退款按钮
  APPLY_LOAN_BUTTON = 'apply_loan_button' // 申请放款按钮
}

/** 退货订单操作按钮 */
export enum ReturnOrderOperateStatus {
  VIEW_BUTTON = 'view_button', // 详情按钮
  CLOSE_RETURN_BUTTON = 'close_return_button', // 关闭退货
  AFTER_SALE_BUTTON = 'after_sale_button', // 申请售后按钮
  WRITE_ORDER_CODE_BUTTON = 'write_order_code_button', // 填写单号按钮
  RETURN_CHECK_BUTTON = 'return_check_button' // 退货验收按钮
}

/** 销售单发票管理 */
export enum InvoiceOperateStatus {
  INVOICE = 'INVOICE', // 开票按钮
  INVOICE_REVERSAL = 'INVOICE_REVERSAL', // 红冲发票按钮
  REISSUE_INVOICE = 'REISSUE_INVOICE' // 重新开票按钮
}

/** 销售订单状态 */
export enum SalesOrderStatus {
  WAIT_CONFIRM = 'wait_confirm', // 待确认
  CONFIRMED = 'confirmed', // 已确认
  WAIT_CHECK = 'wait_check', // 待审核
  WAIT_SUBMIT = 'wait_submit', // 待提交
  WAIT_SCHEDULING = 'wait_scheduling', // 待排产
  CLOSED_ORDER = 'closed_order', // 已关闭
  WAIT_PURCHASE = 'wait_purchase', // 待接单
  WAIT_DELIVERY = 'wait_delivery', // 待发货
  ALL_DELIVERY = 'all_delivery', // 全部发货
  WAIT_SIGN = 'wait_sign', // 待验收
  WAIT_RETURN = 'wait_return', // 退货待申请
  RETURNING = 'returning', // 退货中
  SCUESS_RETURN_ALL = 'scuess_return_all', // 退货成功（全部）
  SCUESS_RETURN_PART = 'scuess_return_part', // 退货成功（部分）
  COMPLETED = 'completed' // 已完成
}

/** 退货订单状态 */
export enum ReturnOrderStatus {
  WAIT_RETURN = 'wait_return', // 待申请
  CLOSE_RETURN = 'close_return', // 关闭退货
  // RETURNING_AFTERSALE = 'returning_aftersale', // 退货中已售后
  // RETURNING_RETURNED = 'returning_returned', // 退货中已完成退货单号
  RETURNING = 'returning', // 退货中
  SCUESS_RETURN_ALL = 'scuess_return_all', // 退货成功（全部）
  SCUESS_RETURN_PART = 'scuess_return_part', // 退货成功（部分）
  FAIL_RETURN = 'fail_return' // 退货失败
}

// 操作类型
export enum BossCabinetOperateType {
  OPEN_MAIN_CABINET_DOOR = 1, // 开启主柜门
  HOST_REBOOT = 2, // 主机重启
  DISABLE = 3, // 禁用
  ONE_CLICK_CABINET_CLEAR = 4, // 一键清柜
  APP_REBOOT = 5, // APP重启
  ENABLE = 6 // 启用
}

// 枚举类型 1设备序号 2设备规格 3品牌厂商 4柜机系统 5柜机类型
export enum BossCabinetEnumType {
  DEVICE_NUM = 1, // 设备序号
  DEVICE_SPEC = 2, // 设备规格
  BRAND = 3, // 品牌厂商
  CABINET_SYSTEM = 4, // 柜机系统
  CABINET_TYPE = 5 // 柜机类型
}

// 中天结算审核-审核状态
export enum BossSettleZTAuditStatus {
  WAITING = -1, // 待审核
  PENDING = 0, // 未审核
  PASS = 1, // 审核通过
  REJECT = 2 // 审核拒绝
}

// 中天结算审核-主订单状态
export enum BossSettleZTOrderStatus {
  REQUESTED = 10, // 已申请
  ONGOING = 20, // 进行中
  TERMINATED = 30, // 已终止
  ARCHIVED = 40 // 已归档
}

// 中天结算列表-详情-扣款明细-结算状态
export enum BossSettleZTSettleStatus {
  WAIT_SETTLE = 0, // 待结算
  SETTLING = 1, // 结算中
  SETTLE_SUCCESS = 2, // 结算成功
  SETTLE_FAIL = -1, // 结算失败
  SETTLE_CALLBACK_FAIL = -2, // 结算回调失败
  SETTLE_CANCEL = -3 // 已作废
}

export enum BlackListDataSource {
  STORE = 1,
  ZTOHEADQUARTERS = 2,
  HEADQUARTERS = 3
}

export enum PreLeaseStatus {
  PENDING = 0, // 待支付
  NOT_STARTED = 1, // 未开始
  IN_PROGRESS = 2, // 进行中
  ENDED = 3 // 已结束
}
export enum BoxTypeEnum {
  MAIN = 0, // 主屏幕
  SMALL = 1, // 小
  MEDIUM = 2, // 中
  LARGE = 3, // 大
  EXTRA_SMALL = 4, // 超小
  SUPER = 5 // 超大
}

/**
 * 点位迁移状态
 */
export enum PointStatus {
  ABNORMAL = 'abnormal', // 状态异常
  PROGRESS = 'progress', // 进行中
  COMPLETED = 'completed' // 已完成
}
